import { agingStatus } from './agingStatus';
import { autoTranslate } from './autoTranslate';
import { availableSellingUnits } from './availableSellingUnits';
import { baseUnit } from './baseUnit';
import { callOffDescription } from './callOffDescription';
import { contactName } from './contactName';
import { convertSellingUnitQuantity } from './convertSellingUnitQuantity';
import { convertToArabicNumber } from './convertToArabicNumber';
import { currency, currencyToWords } from './currency';
import { currentFTProgress } from './currentFTProgress';
import { customerAlias } from './customerAlias';
import { customerArrayFromFg } from './customerArrayFromFg';
import { dateFormat } from './dateFormat';
import { endBalance } from './endBalance';
import { expectedProgress } from './expectedProgress';
import { factoryTicketDescription } from './factoryTicketDescription';
import { filterProducts } from './filterProducts';
import { formatCallOffForLoadingManifest } from './formatCallOffForLoadingManifest';
import { formatOrderForInvoice } from './formatOrderForInvoice';
import { getTotalInvoiceValuesFromDateRange } from './getTotalInvoiceValuesFromDateRange';
import { goodsName } from './goodsName';
import { goodsLocationsOverview } from './goodsQuantity';
import { groupProductionReportsByOrder } from './groupProductionReportsByOrder';
import { invoiceDescription, miscInvoiceDescription } from './invoiceDescription';
import { invoiceVersion } from './invoiceVersion';
import { joinArray } from './joinArray';
import { kgToSellingUnitQuantity } from './kgToSellingUnitQuantity';
import { lastProcess } from './lastProcess';
import { lmOrderDescription } from './lmOrderDescription';
import { mergeArray } from './mergeArray';
import { mergeInvoiceOrderFg } from './mergeInvoiceOrderFg';
import { numberAbbreviation } from './numberAbbreviation';
import { numberToArabic } from './numberToArabic';
import { numFormat, unitPriceFormat } from './numFormat';
import { orderDescription } from './orderDescription';
import { orderFg } from './orderFg';
import { orderProgress } from './orderProgress';
import { orderQuantityInBaseUnit } from './orderQuantityInBaseUnit';
import { ordersArrayForReturnItem } from './ordersArrayForReturnItem';
import { orderTarget } from './orderTarget';
import { packingDetails } from './packingDetails';
import { packingMode } from './packingMode';
import { poCode } from './poCode';
import { productAlias } from './productAlias';
import { productDescription } from './productDescription';
import { productEditFlag } from './productEditFlag';
import { productInvoiceName } from './productInvoiceName';
import { productionProcess } from './productionProcess';
import { productStatus } from './productStatus';
import { purchaseOrder } from './purchaseOrder';
import { qrCodeValue } from './qrCodeValue';
import { qtDescription } from './qtDescription';
import { qtStatus } from './qtStatus';
import { salesDocType } from './salesDocType';
import { salesForecast } from './salesForecast';
import { scEditFlag } from './scEditFlag';
import { sellingUnitQuantityToKg } from './sellingUnitQuantityToKg';
import { statementDescription } from './statementDescription';
import { unit } from './unit';

export const helperFns: any = {
  agingStatus,
  autoTranslate,
  availableSellingUnits,
  baseUnit,
  callOffDescription,
  contactName,
  convertToArabicNumber,
  convertSellingUnitQuantity,
  currency,
  currencyToWords,
  currentFTProgress,
  customerAlias,
  customerArrayFromFg,
  dateFormat,
  endBalance,
  expectedProgress,
  factoryTicketDescription,
  filterProducts,
  formatCallOffForLoadingManifest,
  formatOrderForInvoice,
  getTotalInvoiceValuesFromDateRange,
  goodsName,
  goodsLocationsOverview,
  groupProductionReportsByOrder,
  invoiceDescription,
  invoiceVersion,
  joinArray,
  kgToSellingUnitQuantity,
  lastProcess,
  lmOrderDescription,
  mergeArray,
  mergeInvoiceOrderFg,
  miscInvoiceDescription,
  numberAbbreviation,
  numberToArabic,
  numFormat,
  orderDescription,
  orderFg,
  orderProgress,
  orderQuantityInBaseUnit,
  ordersArrayForReturnItem,
  orderTarget,
  packingDetails,
  packingMode,
  poCode,
  productAlias,
  productEditFlag,
  productInvoiceName,
  productDescription,
  productionProcess,
  productStatus,
  purchaseOrder,
  qrCodeValue,
  qtDescription,
  qtStatus,
  salesDocType,
  salesForecast,
  scEditFlag,
  sellingUnitQuantityToKg,
  statementDescription,
  unit,
  unitPriceFormat
};